import * as React from 'react';

import TextField from 'react-md/lib/TextFields';
import { Cell } from 'react-md/lib/Grids';

import { PersonalDetails } from '../Calculation/types';
import { FieldValidationError } from './FieldValidationError';

interface State {
  emailTouched: boolean;
  nameTouched: boolean;
  numberTouched: boolean;
}

interface Props {
    personalDetails: PersonalDetails;
    nameRequired: boolean;
    emailRequired: boolean;
    numberRequired: boolean;
    validatorErrorMessages: {
      name?: string;
      email?: string;
      number?: string;
    };
    onNameUpdated: (value: string) => void;
    onEmailUpdated: (value: string) => void;
    onNumberUpdated: (value: string) => void;
}

export class PersonalDetailsEntry extends React.Component<Props & React.HTMLAttributes<HTMLDivElement>, State> {
  constructor(props: Readonly<Props>) {
    super(props);

    this.state = {
      emailTouched: false,
      nameTouched: false,
      numberTouched: false
    };
  }

    public render() {
      const { personalDetails } = this.props;
      const nameValidationMessage = this.props.validatorErrorMessages.name;
      const emailValidationMessage = this.props.validatorErrorMessages.email;
      const numberValidationMessage = this.props.validatorErrorMessages.number;


      return <div className={this.props.className}>

      <Cell>
      <div>
        <TextField onBlur={this.onNameBlurred} id="preferredNameInput" type="text" required={this.props.nameRequired} block={false} fullWidth={true} onChange={this.props.onNameUpdated} value={personalDetails.preferredName} placeholder="Enter your name"></TextField>
      </div>
      <FieldValidationError show={this.state.nameTouched && !!nameValidationMessage}>
        {nameValidationMessage}
      </FieldValidationError>
      </Cell>       

      <Cell>
      <div>
        <TextField onBlur={this.onEmailBlurred} name="email" id="emailAddressInput" required={this.props.emailRequired} block={false} type="email" fullWidth={true} onChange={this.props.onEmailUpdated} value={personalDetails.email} placeholder="Enter your email"></TextField>
      </div>
      <FieldValidationError show={this.state.emailTouched && !!emailValidationMessage}>
       {emailValidationMessage}
      </FieldValidationError>
      </Cell>

      <Cell>
      <div>
      <TextField onBlur={this.onNumberBlurred} name="number" id="numberInput" required={this.props.numberRequired} block={false} type="tel" fullWidth={true} onChange={this.props.onNumberUpdated} value={personalDetails.number} placeholder="Enter your phone"></TextField>
      </div>
      <FieldValidationError show={this.state.numberTouched && !!numberValidationMessage}>
       {numberValidationMessage}
      </FieldValidationError>
      </Cell>
      </div>
    }

    private onNameBlurred = () => {
      this.setState({nameTouched: true});
    }

    private onEmailBlurred = () => {
      this.setState({emailTouched: true});
    };

    private onNumberBlurred = () => {
      this.setState({numberTouched: true});
    };
  }